import React from "react";
import { RequiredLabel, ColorWrapper } from "../containers/common-styled";
import moment from "moment/moment";
import constant from "../../../../core/constant";
import ConfirmRemoveModal from "./confirmRemoveModal";
import defaultMenuImage from "../../../../assets/images/default-images-empty.png";

const GourmetSelectMenu = (props) => {
  const {
    user,
    pageColor,
    history,
    match,
    dispatchActions,
    getTotalDiscount,
    getTotalDuration,
    getTotalMoney,
  } = props;

  const [confirmModal, setConfirmModal] = React.useState({
    isShowRemoveDialog: false,
    removeType: "",
    willRemoveThing: null,
  });
  const [menuSelected, setMenuSelected] = React.useState([]);
  const { userBookingData, shopDiscounts } = user;
  const { chosenMenu, chosenTime, selectedDate, special_menu } =
    userBookingData;

  React.useEffect(() => {
    if (!chosenMenu) {
      setMenuSelected([]);
    } else {
      const menusArray = chosenMenu
        .split(",")
        .map((item) => user.shopMenus.find((menu) => menu.id === +item));
      const menus = formatMenuSelected(menusArray);
      setMenuSelected(menus);
    }
  }, [chosenMenu]);

  const removeMenu = (menu) => {
    if (user.confirmWhenRemove === true) {
      setConfirmModal({
        isShowRemoveDialog: true,
        removeType: "menu",
        willRemoveThing: menu,
      });
      return;
    }

    handleResetPriceByMenu(menu);
  };

  const handleResetPriceByMenu = (menu) => {
    const menus = chosenMenu.split(",");
    const index = menus.findIndex((item) => +item === menu.id);
    menus.splice(index, 1);

    const totalMoney = getTotalMoney(menus);

    const totalDuration = getTotalDuration(menus);

    const totalDiscount = getTotalDiscount(menus);

    dispatchActions.setUserBookingData({
      key: match.params.id,
      value: {
        ...userBookingData,
        total: totalMoney,
        duration: totalDuration,
        discount: totalDiscount,
        chosenMenu: menus ? menus.join(",") : "",
      },
    });
  };

  const formatMenuSelected = (menus) => {
    return menus.map((menu) => {
      const discount = user.shopDiscounts?.find(
        (item) => item.id === menu.discount
      );

      if (!isValidDiscount(discount)) {
        return menu;
      }

      let priceAfterDiscount = "";
      if (discount.type === constant.discountType.PERCENTAGE) {
        priceAfterDiscount =
          menu.price - (menu.price * Number(discount.value)) / 100;
      } else {
        priceAfterDiscount = menu.price - Number(discount.value);
      }

      return {
        ...menu,
        priceAfterDiscount,
      };
    });
  };

  const isValidDiscount = (discount) => {
    const { year, month, date } = selectedDate;
    let time = `${year}-${month}-${date} ${chosenTime}`;
    return (
      discount &&
      moment(
        moment(discount.valid_to).format("YYYY-MM-DD HH:mm")
      ).isSameOrAfter(moment(time || new Date()).format("YYYY-MM-DD HH:mm")) &&
      moment(
        moment(discount.valid_from).format("YYYY-MM-DD HH:mm")
      ).isSameOrBefore(moment(time || new Date()).format("YYYY-MM-DD HH:mm"))
    );
  };

  const onCloseConfirmRemoveModal = (data) => {
    setConfirmModal({
      isShowRemoveDialog: false,
      removeType: "",
    });
  };

  const changePage = (path) => {
    history.push(path);
  };

  const formatMoney = (amount) => {
    return amount.toLocaleString("ja-JP");
  };

  const getYouTubeVideoId = (url) => {
    const regex =
      /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  const getYouTubeThumbnail = (url) => {
    const videoId = getYouTubeVideoId(url);
    if (videoId) {
      return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
    }
    return url;
  };

  const renderDiscount = (menu) => {
    const discount = shopDiscounts.find(
      (discount) => discount.id === menu.discount
    );
    let validTo = shopDiscounts.find((d) => d.id === menu.discount)?.valid_to;

    const now = moment().format("YYYY-MM-DDTHH:mm");
    if (!discount || !moment(now).isSameOrBefore(validTo)) {
      return null;
    }

    let value = "";
    if (discount.type === "Other") {
      value = discount.value_other;
    } else {
      value = `${discount.value} ${discount.type === "Fixed" ? "円" : "%"}`;
    }
    return (
      <div className="user-menus__discount-info">
        <ColorWrapper $color="#fc3c60" $isColor className="mb-2">
          ※ 割引：
          {discount.name} ({value})
        </ColorWrapper>
        <ColorWrapper $color="#fc3c60" $isColor className="mb-2">
          ({moment(discount.valid_from).format("YYYY/MM/DD HH:mm")} -{" "}
          {moment(discount.valid_to).format("YYYY/MM/DD HH:mm")})
        </ColorWrapper>
      </div>
    );
  };

  const renderSelectedMenu = () => {
    if (special_menu) {
      return <div className="options__description">席だけ予約する</div>;
    }

    if (!menuSelected.length)
      return (
        <div className="options__description">メニューを選択してください</div>
      );

    return menuSelected.map((menu) => (
      <div key={menu.id}>
        <div className="card border-0 border-bottom py-3">
          <div className="row g-1">
            <div className="col-2">
              <img
                src={getYouTubeThumbnail(menu.image) || defaultMenuImage}
                alt={menu.name}
                className="img-fluid rounded"
                style={{
                  aspectRatio: "1/1",
                  objectFit: "cover",
                }}
              />
            </div>
            <div className="col-10 ps-2">
              <h6 className="card-title fw-bold mb-3 text-dark">{menu.name}</h6>

              {menu.detail && (
                <p className="text-muted small mb-2 lh-sm">{menu.detail}</p>
              )}
              <div className="d-flex align-items-center mb-2">
                <i
                  className="material-icons me-1 text-muted"
                  style={{ fontSize: "18px" }}
                >
                  schedule
                </i>
                <small className="text-muted">{menu.duration}分</small>
              </div>

              <div className="d-flex justify-content-between align-items-center">
                <div className="fw-bold">
                  ¥{formatMoney(Number(menu.priceAfterDiscount || menu.price))}
                </div>
                <button
                  style={{
                    backgroundColor: pageColor,
                  }}
                  className="btn btn-sm px-3 text-white"
                  onClick={() => removeMenu(menu)}
                >
                  削除する
                </button>
              </div>
            </div>
          </div>
          {renderDiscount(menu)}
        </div>
      </div>
    ));
  };

  return (
    <div className="options__item pb-4">
      <div className="options__header">
        <div className="d-flex align-content-center gap-2">
          <i className="fas fa-solid fa-bars"></i>
          <RequiredLabel className="options__label">メニュー</RequiredLabel>
        </div>

        <ColorWrapper
          className="options__chose-btn"
          style={{
            top: "0px !important",
          }}
          $color={pageColor}
          $isColor
          $isBorder
          onClick={() => changePage(`/${match.params.id}/booking/menus`)}
        >
          選択する
        </ColorWrapper>
      </div>
      {renderSelectedMenu()}

      {confirmModal.isShowRemoveDialog && (
        <ConfirmRemoveModal
          type={confirmModal.removeType}
          data={confirmModal.willRemoveThing}
          onClose={onCloseConfirmRemoveModal}
          {...props}
        />
      )}
    </div>
  );
};

export default React.memo(GourmetSelectMenu);
